(() => {
  function init(root) {
    if (root.dataset.awReady) return;
    root.dataset.awReady = 'true';
    const track = root.querySelector('[data-aw-gallery]');
    const slides = Array.from(track?.children || []);
    const thumbs = Array.from(root.querySelectorAll('[data-aw-thumb]'));
    const count = root.querySelector('[data-aw-gallery-count]');
    const prev = root.querySelector('[data-aw-gallery-prev]');
    const next = root.querySelector('[data-aw-gallery-next]');
    const dialog = root.querySelector('[data-aw-dialog]');
    const zoomBody = root.querySelector('[data-aw-zoom-body]');
    const zoomPrev = root.querySelector('[data-aw-zoom-prev]');
    const zoomNext = root.querySelector('[data-aw-zoom-next]');
    const zoomScale = root.querySelector('[data-aw-zoom-scale]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let opener;
    function showZoom() {
      if (!slides[index] || !zoomBody) return;
      const images = Array.from(slides[index].querySelectorAll('img'));
      zoomBody.replaceChildren();
      images.forEach(original => {
        const img = document.createElement('img');
        img.src = original.currentSrc || original.src;
        img.alt = original.alt;
        img.style.setProperty('--aw-image-width', `${original.naturalWidth || original.width}px`);
        zoomBody.appendChild(img);
      });
      // The final slide is text, so render its composition as an enlarged card.
      if (!images.length) {
        const card = slides[index].cloneNode(true);
        card.style.cssText = 'width:100%;height:auto;min-height:500px;aspect-ratio:1;container-type:inline-size';
        zoomBody.appendChild(card);
      }
      zoomBody.classList.remove('is-large');
      if (zoomScale) {
        zoomScale.hidden = !images.length;
        zoomScale.setAttribute('aria-pressed', 'false');
        zoomScale.textContent = 'Zoom in';
      }
      zoomBody.scrollTop = zoomBody.scrollLeft = 0;
      root.querySelector('[data-aw-zoom-title]').textContent = slides[index].getAttribute('aria-label').split(': ')[1];
      root.querySelector('[data-aw-zoom-count]').textContent = `${index + 1} / ${slides.length}`;
      zoomPrev.disabled = index === 0;
      zoomNext.disabled = index === slides.length - 1;
    }
    function update() {
      if (!track || !slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      count.textContent = `${index + 1} / ${slides.length}`;
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    }
    function go(target, inDialog = false) {
      index = Math.max(0, Math.min(slides.length - 1, target));
      track.scrollTo({ left: index * track.clientWidth, behavior: inDialog || reduced ? 'instant' : 'smooth' });
      if (inDialog) showZoom();
    }
    let frame;
    track?.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track?.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    root.querySelector('[data-aw-zoom]')?.addEventListener('click', e => {
      opener = e.currentTarget; showZoom(); dialog.showModal(); document.body.style.overflow = 'hidden';
    });
    root.querySelector('[data-aw-close-zoom]')?.addEventListener('click', () => dialog.close());
    zoomScale?.addEventListener('click', () => {
      const enlarged = zoomBody.classList.toggle('is-large');
      zoomScale.setAttribute('aria-pressed', String(enlarged));
      zoomScale.textContent = enlarged ? 'Fit page' : 'Zoom in';
      zoomBody.scrollTop = zoomBody.scrollLeft = 0;
    });
    dialog?.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog?.addEventListener('close', () => { document.body.style.overflow = ''; opener?.focus(); });
    zoomPrev?.addEventListener('click', () => go(index - 1, true));
    zoomNext?.addEventListener('click', () => go(index + 1, true));
    dialog?.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1), true); }
    });
    if (track) {
      new ResizeObserver(() => { track.scrollTo({left:index * track.clientWidth,behavior:'instant'}); update(); }).observe(track);
      update();
    }

    const reviewDialog = root.querySelector('[data-aw-review-dialog]');
    const reviewImage = root.querySelector('[data-aw-review-zoom-image]');
    let reviewOpener;
    let reviewOverflow;
    root.querySelectorAll('[data-aw-review-photo]').forEach(button => button.addEventListener('click', () => {
      const photo = button.querySelector('img');
      if (!photo || !reviewDialog || !reviewImage) return;
      reviewOpener = button;
      reviewOverflow = document.body.style.overflow;
      reviewImage.src = photo.currentSrc || photo.src;
      reviewImage.alt = photo.alt;
      reviewDialog.querySelector('.aw-zoom-body').scrollTo(0, 0);
      reviewDialog.showModal();
      document.body.style.overflow = 'hidden';
    }));
    root.querySelector('[data-aw-close-review-photo]')?.addEventListener('click', () => reviewDialog.close());
    reviewDialog?.addEventListener('click', e => { if (e.target === reviewDialog) reviewDialog.close(); });
    reviewDialog?.addEventListener('close', () => {
      document.body.style.overflow = reviewOverflow || '';
      reviewOpener?.focus();
    });

    const extraReviews = Array.from(root.querySelectorAll('[data-aw-more-review]'));
    const reviewToggle = root.querySelector('[data-aw-reviews-toggle]');
    if (extraReviews.length && reviewToggle) {
      extraReviews.forEach(review => review.hidden = true);
      reviewToggle.hidden = false;
      reviewToggle.addEventListener('click', () => {
        const expanded = reviewToggle.getAttribute('aria-expanded') === 'true';
        extraReviews.forEach(review => review.hidden = expanded);
        reviewToggle.setAttribute('aria-expanded', String(!expanded));
        reviewToggle.textContent = expanded ? `See all ${reviewToggle.dataset.awReviewTotal} reviews` : 'Show fewer reviews';
        if (expanded) reviewToggle.scrollIntoView({block:'nearest',behavior:reduced?'instant':'smooth'});
      });
    }

    const form = root.querySelector('[data-aw-product-form]');
    const select = root.querySelector('[data-aw-variant-select]');
    const sticky = root.querySelector('[data-aw-sticky]');
    const error = root.querySelector('[data-aw-cart-error]');
    const buy = form?.querySelector('[data-aw-buy]');
    const buttons = Array.from(root.querySelectorAll('[data-aw-action],[data-aw-scroll-buy]'));
    const baseRoute = window.Shopify?.routes?.root || '/';
    let busy = false;
    if (select) select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      root.querySelectorAll('[data-aw-price],[data-aw-sticky-price]').forEach(el => el.textContent = option.dataset.price);
      const price = Number(option.dataset.priceRaw || 0);
      const compare = Number(option.dataset.compareRaw || 0);
      const compareEl = root.querySelector('[data-aw-compare]');
      const discountEl = root.querySelector('[data-aw-discount]');
      compareEl.textContent = option.dataset.compare || '';
      compareEl.hidden = discountEl.hidden = compare <= price;
      discountEl.textContent = compare > price ? `${Math.round((compare-price)/compare*100)}% off` : '';
      buttons.forEach(button => button.disabled = option.dataset.available !== 'true');
      if (buy) buy.textContent = option.dataset.available === 'true' ? 'Buy now' : 'Sold out';
    });
    if (form) form.addEventListener('submit', async e => {
      if (busy || !buy || buy.disabled) { e.preventDefault(); return; }
      e.preventDefault();
      const submitter = e.submitter || buy;
      const action = submitter.dataset.awAction || 'checkout';
      const old = submitter.textContent;
      busy = true;
      error.hidden = true;
      const data = new FormData(form);
      buttons.forEach(button => button.disabled = true);
      if (select) select.disabled = true;
      submitter.textContent = 'Adding…';
      try {
        const result = await fetch(baseRoute + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:data});
        if (!result.ok) {
          const detail = await result.json().catch(() => ({}));
          throw new Error(detail.description || 'The planner could not be added. Please try again.');
        }
        window.location.assign(baseRoute + (action === 'cart' ? 'cart' : 'checkout'));
      } catch (err) {
        // Do not submit a second add request after an uncertain network result.
        error.textContent = err instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : err.message;
        const cartLink = document.createElement('a');
        cartLink.href = baseRoute + 'cart'; cartLink.textContent = ' View cart';
        error.appendChild(cartLink); error.hidden = false;
        buttons.forEach(button => button.disabled = false);
        if (select) select.disabled = false;
        submitter.textContent = old;
        busy = false;
      }
    });
    root.querySelectorAll('[data-aw-scroll-buy]').forEach(button => button.addEventListener('click', () => {
      if (form && buy && !buy.disabled && !busy) form.requestSubmit(buy);
    }));
    if (sticky && form) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      observer.observe(form);
    }
  }
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-aw-listing]').forEach(init));
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-aw-listing]').forEach(init));
})();
